import { type FormEvent } from "react";
import { Link } from "react-router-dom";
import { HeroMinimal, SectionHeader } from "../components/sections";
import { ArrowUpRight, Mail, ArrowRight } from "lucide-react";

export default function ContactPage() {
  const prepareEmail = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const body = `Name: ${data.get("name")}\nEmail: ${data.get("email")}\nCompany: ${data.get("company")}\n\n${data.get("message")}`;
    window.location.href = `mailto:hello@uniqreach.com?subject=${encodeURIComponent(String(data.get("subject") || "UniqReach inquiry"))}&body=${encodeURIComponent(body)}`;
  };
  return (
    <>
      <HeroMinimal
        title="Let's talk about what comes next."
        subtitle="Questions about outbound, AI, automation, or a possible partnership? Start a conversation with our team."
        ctaText="Book a Strategy Call"
        ctaHref="/book"
        secondaryCtaText="Browse FAQs"
        secondaryCtaHref="/faq"
      />
      <section className="section" aria-labelledby="contact-title">
        <div className="container editorial-grid contact-layout">
          <div>
            <SectionHeader
              id="contact-title"
              eyebrow="Get in touch"
              title="A clear path to the right conversation."
              description="For a sales system discussion, book a strategy call. For general questions or partnerships, email us directly."
            />
            <a href="mailto:hello@uniqreach.com" className="text-link mt-8">
              <Mail size={20} aria-hidden="true" />
              hello@uniqreach.com
              <ArrowUpRight size={18} aria-hidden="true" />
            </a>
            <div className="card p-6 mt-8">
              <h3 className="h3 mb-3">Exploring an outbound system?</h3>
              <p className="body text-text-secondary">
                Tell us about your buyers, your current sales process, and where
                you want to grow.
              </p>
              <Link to="/book" className="text-link mt-4">
                Book a Strategy Call
                <ArrowRight size={18} aria-hidden="true" />
              </Link>
            </div>
          </div>
          <form className="card-elevated contact-form" onSubmit={prepareEmail}>
            <h2 className="h3 mb-6">Prepare your message</h2>
            <div className="grid sm:grid-cols-2 gap-5">
              <div>
                <label htmlFor="contact-name" className="label-base">
                  Name
                </label>
                <input
                  id="contact-name"
                  name="name"
                  className="input-base"
                  autoComplete="name"
                  required
                  maxLength={120}
                />
              </div>
              <div>
                <label htmlFor="contact-email" className="label-base">
                  Work email
                </label>
                <input
                  id="contact-email"
                  name="email"
                  type="email"
                  className="input-base"
                  autoComplete="email"
                  required
                  maxLength={254}
                />
              </div>
            </div>
            <div>
              <label htmlFor="contact-company" className="label-base">
                Company <span className="text-text-muted">(optional)</span>
              </label>
              <input
                id="contact-company"
                name="company"
                className="input-base"
                autoComplete="organization"
                maxLength={160}
              />
            </div>
            <div>
              <label htmlFor="contact-subject" className="label-base">
                Subject
              </label>
              <select
                id="contact-subject"
                name="subject"
                className="input-base"
              >
                <option>General inquiry</option>
                <option>Outbound sales systems</option>
                <option>Technical question</option>
                <option>Partnership</option>
              </select>
            </div>
            <div>
              <label htmlFor="contact-message" className="label-base">
                Your message
              </label>
              <textarea
                id="contact-message"
                name="message"
                className="input-base min-h-[150px]"
                required
                maxLength={5000}
              />
            </div>
            <button type="submit" className="btn btn-primary">
              Open email draft
              <ArrowUpRight size={17} aria-hidden="true" />
            </button>
            <p className="caption text-text-muted">
              Opens your email app with a draft. Review it there before sending.
            </p>
          </form>
        </div>
      </section>
    </>
  );
}
